import React, { useEffect, useState } from "react";
import Input from "sushiweb/InputTypes/Input";
import Button from "sushiweb/Button";
import styles from "../../../constants/assets/variables";
import { connect } from "react-redux";
import * as AssetsIssuanceActions from "../../../store/actions/AssetsIssuance";

import { validateForm, filterObj } from "../../../utils";
import { bindActionCreators } from "redux";

const filterFields = ["phone_number", "pan_number"];
const VerifyIssuability = (props) => {
  const { driverDetails, completed, disabled, next, verifyIssuability } = props;
  const [inputDisabled, setInputDisabled] = useState(true);
  const [localLoader, setLocalLoader] = useState(false);
  const [currentDriverCredential, setCurrentDriverCredential] = useState({
    phone_number: "",
    pan_number: "",
  });

  const [currentFormError, setCurrentFormError] = useState({
    phone_number: "",
    pan_number: "",
  });

  const handleChange = (key, val) => {
    let values = { ...currentDriverCredential };
    values[key] = val;
    setCurrentDriverCredential(values);
  };

  useEffect(() => {
    setInputDisabled(completed || disabled);
  }, [completed, disabled]);

  useEffect(() => {
    setCurrentDriverCredential({
      phone_number: driverDetails.phone_number,
      pan_number: driverDetails.pan_number,
    });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputDisabled) {
      return;
    }
    let body = filterObj(currentDriverCredential, filterFields);
    setCurrentFormError({
      phone_number: "",
      pan_number: "",
    });
    let validationState = validateForm(body, {
      phone_number: "mandatory",
      pan_number: "mandatory",
    });
    if (validationState !== true) {
      let newError = { ...currentFormError };
      if (validationState["phone_number"]) {
        newError["phone_number"] = validationState["phone_number"];
      }
      if (validationState["pan_number"]) {
        newError["pan_number"] = validationState["pan_number"];
      }
      setCurrentFormError(newError);
    } else {
      setLocalLoader(true);
      const payload = {
        pan_no: currentDriverCredential.pan_number,
        phone_no: currentDriverCredential.phone_number,
      };
      verifyIssuability(payload).then((result) => {
        if (result) {
          next();
        }
        setLocalLoader(false);
      });
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Input
          disabled={inputDisabled}
          value={currentDriverCredential.phone_number}
          onChange={(e) => handleChange("phone_number", e)}
          id="sushi-input"
          label="Driver Phone number"
          required
          fullWidth
          borderColor={styles.primaryColor}
          errorMsg={currentFormError.phone_number}
          autoFocus
        />
        <Input
          disabled={inputDisabled}
          value={currentDriverCredential.pan_number}
          onChange={(e) => handleChange("pan_number", e)}
          id="sushi-input"
          label="Driver PAN CARD number"
          required
          fullWidth
          borderColor={styles.primaryColor}
          errorMsg={currentFormError.pan_number}
        />
        <Button
          type="submit"
          loading={localLoader}
          onClick={handleSubmit}
          disabled={inputDisabled}
        >
          Submit
        </Button>
      </form>
    </div>
  );
};

function mapStateToProps(state) {
  const { AssetsIssuance } = state;
  return {
    driverDetails: AssetsIssuance.driverDetails,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    verifyIssuability: bindActionCreators(
      AssetsIssuanceActions.verifyIssuability,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifyIssuability);
